export const allChecks = [
  {
    id: 1,
    retailer: 'Dollar General',
    check: '#DG-9982',
    date: 'Feb 18, 2026',
    status: 'not-started',
    deduction: '$48,200',
    approved: 0,
    rejected: 0,
    pending: 5,
  },
  {
    id: 2,
    retailer: 'Dollar General',
    check: '#DG-8821',
    date: 'Feb 18, 2026',
    status: 'in-progress',
    deduction: '$12,500',
    approved: 12,
    rejected: 8,
    pending: 20,
  },
  {
    id: 3,
    retailer: 'Walmart',
    check: '#WM-2219',
    date: 'Feb 17, 2026',
    status: 'in-progress',
    deduction: '$31,800',
    approved: 10,
    rejected: 5,
    pending: 20,
  },
  {
    id: 4,
    retailer: 'Dollar General',
    check: '#DG-1102',
    date: 'Feb 2, 2026',
    status: 'completed',
    deduction: '$8,900',
    approved: 6,
    rejected: 2,
    pending: 0,
  },
  {
    id: 5,
    retailer: 'Dollar General',
    check: '#DG-5591',
    date: 'Jan 16, 2026',
    status: 'completed',
    deduction: '$5,400',
    approved: 1,
    rejected: 0,
    pending: 0,
  },
  {
    id: 6,
    retailer: 'Target',
    check: '#TGT-3321',
    date: 'Jan 10, 2026',
    status: 'completed',
    deduction: '$15,200',
    approved: 32,
    rejected: 0,
    pending: 0,
  },
]
